import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { UnitActions } from "redux/actions/settings/UnitActions";
import { ModalActions } from "redux/actions/ModalActions";
import { StoreModel } from "models/StoreModel";
import { LoginUser } from "models/LoginUser";
import { Unit } from "models/Unit";
import { TableColumn, Table, TableRow } from "app/components/common/Table";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import { Translations } from "models/Translations";
import Translator from "app/components/common/Translator";
import { UnitUsageTypeActions } from "redux/actions/settings/UnitUsageTypeActions";
import { UnitUsageType } from "models/UnitUsageType";
import { UnitUsage } from "models/UnitUsage";
import { Translate } from "infrastructure/mapping/Translate";

interface Props {
    fetchUnits: typeof UnitActions.fetchUnits;
    fetchUnitUsageTypes: typeof UnitUsageTypeActions.fetchUnitUsageTypes;
    addUnitForm: typeof ModalActions.showModal;
    addUnit: typeof UnitActions.addUnit;
    editUnitForm: typeof ModalActions.showModal;
    editUnit: typeof UnitActions.editUnit;
    deleteUnit: typeof UnitActions.deleteUnit
    loginUser: LoginUser;
    units: Unit[];
    unitUsageTypes: UnitUsageType[];
    translations: Translations;
}

class UnitsComp extends React.Component<Props> {

    componentDidMount() {
        if (this.loggedIn())
            if (!this.props.units)
                this.props.fetchUnits(this.props.loginUser.token);
            if (!this.props.unitUsageTypes)
                this.props.fetchUnitUsageTypes(this.props.loginUser.token);
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    ready() {
        return this.loggedIn() && this.props.units && this.props.unitUsageTypes
    }

    setTableData(): TableRow[] {
        let data: TableRow[] = [];
        {
            this.props.units.forEach(unit => {
                let usageFor: string = "";
                let tUUs: UnitUsage[] = []; 
                unit.unitUsages.forEach((u, idx) => {
                    const tUt: UnitUsageType = {id: u.unitUsageType.id, name: Translate.text(this.props.translations, u.unitUsageType.name)};
                    const tUu = {...u, unitUsageType: tUt};
                    tUUs.push(tUu);
                    if (idx > 0) {
                        usageFor += ", ";
                    }
                    usageFor += this.props.unitUsageTypes[u.unitUsageType.id].name;
                });
                data.push({
                    dataObject: {
                        id: unit.id,
                        short: unit.short,
                        name: unit.name,
                        unitUsages: tUUs,
                        archivedDate: unit.archivedDate
                    },
                    cells: [
                        {
                            name: "unitUsages",
                            sortVal: usageFor,
                            cell: <Translator text={usageFor} />,
                        }
                    ]
                })
            })
        }
        return data;
    }

    setColumns(): TableColumn[] {
        // TODO maybe dynamic??
        return [
            {
                header: 'Id',
                accessor: 'id',
            },
            {
                header: 'Unit',
                accessor: 'short',
            },
            {
                header: 'Description',
                accessor: 'name',
            },
            {
                header: 'Used for',
                accessor: 'unitUsages',
            }
        ];
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="Units" />
                    <Translator text="Loading" />
                </div>
            )
        }
        const unitUsages = this.props.unitUsageTypes.map((ut, idx) => {
            let tUt: UnitUsageType = {id: ut.id, name: Translate.text(this.props.translations, ut.name)};
            const newUu: UnitUsage = {id: idx, unitUsageType: tUt }; // using the index as an id is a bit of a crapshute, its discarded on the write operation
            return newUu;
        })
        return (
            <div className="c-page__content">
                <PageContentHeader text="Unit" />
                <div className="c-card">
                    <Table
                        addAction={this.props.addUnit}
                        addFormAction={this.props.addUnitForm}
                        addFormData={{
                            header: "Add a new Unit",
                            formObject: Unit.newEmpty(unitUsages)
                        }}
                        editAction={this.props.editUnit}
                        editFormAction={this.props.editUnitForm}
                        editFormData={{
                            header: "Edit Unit",
                        }}
                        deleteAction={this.props.deleteUnit}
                        editable={true}
                        columns={this.setColumns()}
                        tableData={this.setTableData()}
                        translations={this.props.translations}
                        loginUser={this.props.loginUser}
                        nonSelectables={['unit']}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        units: state.units,
        unitUsageTypes: state.unitUsageTypes,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        fetchUnits: bindActionCreators(UnitActions.fetchUnits, dispatch),
        fetchUnitUsageTypes: bindActionCreators(UnitUsageTypeActions.fetchUnitUsageTypes, dispatch),
        addUnit: bindActionCreators(UnitActions.addUnit, dispatch),
        addUnitForm: bindActionCreators(ModalActions.showModal, dispatch),
        editUnit: bindActionCreators(UnitActions.editUnit, dispatch),
        editUnitForm: bindActionCreators(ModalActions.showModal, dispatch),
        deleteUnit: bindActionCreators(UnitActions.deleteUnit, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UnitsComp);